import { addDays, addYears, format } from 'date-fns';

export function createStringDate(days = 0, years = 0): string {
    const date = addDays(new Date(), days);
    return format(addYears(date, years), 'yyyy-MM-dd');
}
